import { createAsyncThunk } from '@reduxjs/toolkit';

import type { InoGatewayResponse } from '@/Module/Core/Model/ApiModel';
import type { IFAQTypeList } from '@/Module/Question/Model';
import FAQService from '@/Module/Question/Service/FAQService';

export const getFAQTypeListAction = createAsyncThunk<InoGatewayResponse<IFAQTypeList[]>>(
  'question/FAQGetTypeList',
  (_, { signal }) => {
    return FAQService.getFAQTypeList(
      {
        Page: 0,
        PageSize: 8,
      },
      signal,
    ).then(({ data }) => data);
  },
);
